import {
  type PageEntity,
  apiClient,
  type ShipmentCategoryEntity
} from '@/libs/api'
import { type ShipmentCategoriesRequestQuery } from '@/libs/api/types'

export type FetchShipmentCategoriesListQuery = {
  tenantKey: string
  query?: ShipmentCategoriesRequestQuery
  dcId?: number
}

export type FetchShipmentCategoriesListResponse = {
  data: ShipmentCategoryEntity[]
  pagination: PageEntity | null
}

/**
 * 配送種別一覧を取得
 */
export const fetchShipmentCategoriesList = async (
  { tenantKey, query, dcId }: FetchShipmentCategoriesListQuery,
  signal?: AbortSignal
): Promise<FetchShipmentCategoriesListResponse> => {
  const finalQuery = {
    ...query,
    ...(dcId ? { dcId } : {})
  }

  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .shipment_categories.list.$get({
      query: finalQuery,
      config: {
        signal
      }
    })

  return {
    data,
    pagination
  }
}
